export { default } from "./Prop65Message";
